import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import QuestionHeader from '../QuestionHeader';

const BooleanToggleType = ({ question, onUpdateVariable, skipTopMargin }) => {
  const { option, description, value } = question;
  const { selected } = option;

  const onChange = useCallback(
    (checked) => {
      onUpdateVariable(checked);
    },
    [onUpdateVariable],
  );

  return (
    <React.Fragment>
      <div>
        <div className="flex w-full flex-justify-between flex-align-items--center">
          <QuestionHeader question={question} skipTopMargin={skipTopMargin} />
          <Switch
            defaultChecked={selected}
            checked={value}
            name={option.name}
            onChange={onChange}
            className="margin-top-md"
          />
        </div>
        <div className="position-relative">
          <p className="color-grey-9" style={{ maxWidth: '420px' }}>
            {description}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

BooleanToggleType.propTypes = {
  question: PropTypes.object,
  onUpdateVariable: PropTypes.func.isRequired,
  skipTopMargin: PropTypes.bool,
};

export default BooleanToggleType;
